module.exports = __webpack_public_path__ + "img/img_ant.1aa13905.png";